import { Link as MUILink } from "@mui/material";
import { PropsWithChildren } from "react";
import { Link, To } from "react-router";

type GaiaSubtleLinkProps = PropsWithChildren<{
    to: To;
}>;

export function GaiaSubtleLink({ to, children }: GaiaSubtleLinkProps) {
    return (
        <MUILink color="inherit" underline="hover" component={Link} to={to}>
            {children}
        </MUILink>
    );
}
